import './App.css';

import {
  BrowserRouter as Router,
    Switch,
    Route,
} from 'react-router-dom';
import Placeholder from "./pages/Placeholder";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="*">
          <Placeholder/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
